<svelte:head>
	{#if !isAnonymous}
	<!-- Primary Meta Tags -->
  <title>D-NS Studio | Mi Cuenta</title>
  <meta name="title" content="D-NS Studio | Mi Cuenta">
  <meta name="description" content="Configura tu cuenta">
	<!-- FB Tags -->
	<meta property="og:url" content="https://d-ns.studio/my-account/">
	<meta property="og:title" content="D-NS Studio | Mi Cuenta">
	<meta property="og:description" content="Configura tu cuenta">
	<meta property="og:image" content="https://d-ns.studio/images/d-ns-panel.jpg">
	<!-- Twitter Tags -->
	<meta property="twitter:url" content="https://d-ns.studio/my-account/">
  <meta property="twitter:title" content="D-NS Studio | Mi Cuenta">
  <meta property="twitter:description" content="Configura tu cuenta">
  <meta property="twitter:image" content="https://d-ns.studio/images/d-ns-panel.jpg">
	{:else}
		<SocialTags
		pageTitle="Inicia Sesión"
		pageDesc="Utiliza tu usuario y contraseña con los que te registraste para iniciar sesión."
	></SocialTags>
	{/if}
</svelte:head>

<style src="./style.scss">

</style>

<main id="dnsPageSignup" class="mbsc-grid d-ns-page my-account-page">
	<nav>
		<MainMenu
			on:menuTapped={togglePages}
      selectedItem='account'
			path={router.path}
		></MainMenu>
	</nav>	

	{#if !isAnonymous}
	<MemberAccount></MemberAccount>
	{:else}
	<SignInForm></SignInForm>
	{/if}

	<footer class="mbsc-row">
		<nav class="mbsc-col-12">
			<FooterMenu></FooterMenu>
		</nav>
		<CopyrightFooter></CopyrightFooter>
	</footer>
</main>

<script>
import { onMount, afterUpdate } from 'svelte';

import SocialTags from '@Components/SocialTags/index.svelte';
import MainMenu from '@Components/MainMenu/index.svelte';

import SignInForm from '@Pages/MyAccount/content.svelte';
import MemberAccount from '@Components/MemberAccount/index.svelte';

import FooterMenu from '@Components/FooterMenu/index.svelte';
import CopyrightFooter from '@Components/CopyrightFooter/index.svelte';

import { AWSAuth, Navigation, Utils } from '@Services';

export let router = null;

let isAnonymous = true;

const DEBUG = document.location.protocol === 'http:' ? true : false;

let togglePages = (event) => {
  Navigation.goTo(event.detail.item);
};

afterUpdate(() => {
	AWSAuth.isAnonymous().then(user => {
		isAnonymous = user;
	});
});

onMount(async () =>{
	console.info('App ' + DEBUG + '::' + router.path);
	
  mobiscroll.settings = {
		theme: 'd-ns',
		themeVariant: 'light',
		lang: 'es'
	};

	mobiscroll.page('.my-account-page', {});
	
	Utils.scrollToTop();
});
</script>
